import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import { useLocation, useLocalStorage } from "react-use";

import { FirebaseContext } from "../Firebase";
import { useSignInWithEmailLink } from "./hooks";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function LoginVerifyEmailLinkPage({ submitEmailValue }) {
  const classes = useStyles();
  const firebase = React.useContext(FirebaseContext);
  const location = useLocation();
  const [
    localStorageEmail,
    setLocalStorageEmail,
    removeEmail,
  ] = useLocalStorage("LS_USER_EMAIL");

  const { loading, error } = useSignInWithEmailLink(
    location.href,
    localStorageEmail,
    removeEmail,
    firebase
  );

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {loading && <p>Loading...</p>}
          {error && <p>Error</p>}
          {!localStorageEmail && (
            <p>
              Скорее всего вы отправляли ваш Email из другого браузера. Поэтому,
              скопируйте ссылку в письме и вставьте ее в тот браузер в котором
              вводили ваш Email. Спасибо
            </p>
          )}
        </Typography>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
